import vindrApi				from "../utils/vindrapi";





class authApi {
	
	token =  "";
	expires = "";
	
	apiUrl = '/.auth';
	userEndpoint				= ()				=> `${this.apiUrl}/me/`;
	headers = {
		'Content-Type': 'application/json'
	};
	constructor() {
		if (authApi.instance) {
			return authApi.instance;
		}
		authApi.instance = this;
		return this;
	}	
	async getUser(){
		
		return this.getUserFromAzure().then((user)=>{
			
			return Promise.all([
				Promise.resolve(user),
				vindrApi.getSettings(user)
			]).then((results)=>{
				
				if(!results[1])
					results[1] = {
						"areaUnit": "meter",
						"filters": {},
						"turbineStyles": {},
						"recentProjects": []
					};
				
				return {
					...results[0],
					settings:results[1]
				}
			});
		}).catch((e)=>{
			
		});
		
	}
	
	
	async getUserFromAzure(){
		try {
			if(window.location.host == "localhost:3000")
				return {
					"identityProvider": "aad",
					"userId": "4f8f810bce694262b01d2350fb0c85ef",
					"userDetails": "here@here.com",
					"userRoles": [
						"user",
						"anonymous",
						"authenticated"
					]
				};
			const response = await fetch(this.userEndpoint(''), this.headers);
			const user = await response.json();
			
			if(user.clientPrincipal)
				return user.clientPrincipal;
			
			return {};
		} catch (error) {
			console.error('Error fetching user:', error);
			throw error;
		}
	}

};

export default new authApi();